iScreenWizard.factory('Taal', function ($q, Ajax) {

    var data = {};

    data.all = function() {
        return $q(function (resolve, reject) {
            Ajax.get('taal').then(function (response) {
                var talen = response.data;
                resolve(talen);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('taal/'+id).then(function (response) {
                var taal = response.data;
                resolve(taal);
            }, reject);
        });
    };

    return data;
});